import { styledStitches } from "@/app/design-system/styles/stitches.config";

export const EmrLink = styledStitches("a", {
  color: "$blue11",
  fontSize: 14,
});
